import { useIntl } from 'react-intl';
// eslint-disable-next-line import/no-unresolved
import { Content } from '@plone/types';
import { sanitizeHighlighting } from '@designsystem/utils/sanitize';
import { filterObject } from '@designsystem/stories/01-core/Utilities';
import { Card, CardProps } from '@designsystem/stories/03-molecules/Card';
import {
  NormalizableContent,
  transformToCard,
} from '@fhnw/helpers/DesignSystem/cardTransformers';
import messages from '@fhnw/messages/types';
import GlobalSearchBreadcrumbs from '@fhnw/components/GlobalSearch/GlobalSearchBreadcrumbs';

type DefaultResultProps = {
  closeGlobalSearch: () => void;
  item: Content & { extras?: Record<string, any> };
};

const DefaultGlobalSearchResultItem = ({
  item,
  closeGlobalSearch,
}: DefaultResultProps) => {
  const intl = useIntl();
  const data: Record<string, any> = {
    ...filterObject(item, null, ['extras']),
    ...item?.extras,
  };

  if (data?.image_scales && typeof data.image_scales === 'string') {
    try {
      data.image_scales = JSON.parse(data.image_scales);
    } catch (e) {
      data.image_scales = null;
    }
  }

  const card: CardProps = filterObject(
    transformToCard(data as NormalizableContent, intl),
    ['title', 'description', 'link', 'type'],
  ) as CardProps;

  if (data.highlighting_title) {
    card.title = (
      <>
        {card.type === 'person' && data?.name_affix1 && (
          <>{data.name_affix1} </>
        )}
        <span
          dangerouslySetInnerHTML={
            {
              __html: sanitizeHighlighting(data.highlighting_title.join('')),
            } as { __html: string }
          }
        />
      </>
    );
  }

  if (data.highlighting_role) {
    card.description = (
      <span
        dangerouslySetInnerHTML={
          {
            __html: sanitizeHighlighting(data.highlighting_role.join('')),
          } as { __html: string }
        }
      />
    );
  } else if (data.highlighting_description) {
    card.description = (
      <span
        dangerouslySetInnerHTML={
          {
            __html: sanitizeHighlighting(
              data.highlighting_description.join(''),
            ),
          } as { __html: string }
        }
      />
    );
  }

  return (
    <Card
      {...card}
      type="search"
      category={intl.formatMessage(
        messages?.[item['@type']] || { id: item['@type'], defaultMessage: '' },
      )}
      onClick={closeGlobalSearch}
    >
      <GlobalSearchBreadcrumbs
        item={item}
        closeGlobalSearch={closeGlobalSearch}
      />
    </Card>
  );
};

export default DefaultGlobalSearchResultItem;
